import {RequestInformation} from "./RequestInformation";
import {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {get, handleApiError, handleExpiredEntryLinkError, post} from "../../js/api";
import {BreadCrumb} from "../../component/Breadcrumb";
import {OrderCorrespondence, prepareOrderCorrespondenceMessage} from "../../component/OrderCorrespondence";
import {Layout} from "../../component/layout/Layout";
import {Button} from "../../component/form/Button";
import {showError, showMessage} from "../../js/main";
import {RefreshSignal} from "../../js/util";
import {orderCorrespondenceType, orderType} from "../../js/constants";
import {SignOrder} from "../../component/SignOrder";
import {useTanPrefill} from "../../js/useTanPrefill";
import {AccordionSection} from "../../component/AccordionSection";

const refresh = new RefreshSignal();
const adminCorrespondenceTypes = [
    orderCorrespondenceType.information,
    orderCorrespondenceType.question,
    orderCorrespondenceType.keycard
];

export const UpdateGuestRequest = ({}) => {

    const [order, setOrder] = useState();
    const [reply, setReply] = useState();
    const [communicationOpen, setCommunicationOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const {token} = useParams();
    const initialTan = useTanPrefill();
    const [confirmed, setConfirmed] = useState(false);

    const openCommunicationForAdminMessage = useCallback((messages) => {
        const lastMessage = messages?.[messages.length - 1];
        if (lastMessage && adminCorrespondenceTypes.includes(lastMessage.type)) {
            setCommunicationOpen(true);
        }
    }, []);

    useEffect(() => {
        try{
            JSON.parse(new TextDecoder().decode(
                Uint8Array.from(atob(token), c => c.charCodeAt(0))
            ));
        }catch (err){
            showError("Der Link ist ungültig. Klicken Sie bitte entweder auf den Link aus der E-Mail. Falls Sie ihn kopieren und einfügen müssen gehen Sie bitte sicher, dass er vollständig kopiert wird.")
            return;
        }
        get(`/public/orders/${token}`, false).then(order => {
            if(order.type == orderType.standard){
                window.location = `/public-order/${token}`;
            }else{
                setOrder(order);
            }
        }).catch(e => {
            if (!handleExpiredEntryLinkError(e)) {
                handleApiError(e);
            }
        });
    }, [token]);

    const updateOrder = async () => {
        setSubmitting(true);
        try {
            const message = await prepareOrderCorrespondenceMessage(reply, true);
            await post(`/public/orders/${token}/correspondence`, message, false);
            showMessage("Die Antwort wurde erfolgreich gespeichert");
            refresh.changed();
        } catch (e) {
            if (!handleExpiredEntryLinkError(e)) {
                showError("Die Antwort konnte nicht gesendet werden. Bitte versuchen Sie es erneut.");
            }
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <Layout username={null}>
                <BreadCrumb currentTitle="Anfrage: Nachschlüssel"/>
                {order && <>
                    {order.state === "CREATED" && <SignOrder order={order} orderToken={token}
                        isPublic={true} cancelable={false} initialTan={initialTan}
                        signed={updated => { setOrder(updated); setConfirmed(true); }}
                        tanFailed={() => setOrder(current => ({...current, state: "CANCELED"}))}/>}
                    {confirmed && <>
                        <h1>Vielen Dank - Ihre Anfrage ist eingegangen!</h1>
                        <div>
                            Ihre Anfrage wird geprüft. In Kürze erhalten Sie eine E-Mail mit folgenden Informationen:
                            <ul>
                                <li>Erfolgreiche Prüfung der Schlüsselbilder</li>
                                <li>Rückmeldung, ob zusätzliche Unterlagen oder eine Berechtigung erfolderlich sind</li>
                                <li>Konkretes Angebot mit Preis pro Schlüssel inkl. Versandkosten</li>
                                <li>Voraussichtliche Lieferzeit</li>
                            </ul>
                        </div>
                        <h2>Informationen zur Bezahlung und zum Ablauf</h2>
                        <p>Wir starten die Produktion erst nach Bestätigung des Angebots, welches Sie erhalten werden.</p>
                    </>}

                    <div className="customer-accordion">
                        <AccordionSection title="Anfrageinformationen" defaultOpen>
                            <RequestInformation order={order} hideHeader/>
                        </AccordionSection>
                        <AccordionSection title="Kommunikation"
                                          open={communicationOpen}
                                          onOpenChange={setCommunicationOpen}>
                            <form onSubmit={e => {
                                e.preventDefault()
                                updateOrder();
                            }}>
                                <OrderCorrespondence adminView={false} identifier={token} isPublic={true}
                                                     onCreateReply={setReply}
                                                     onMessagesLoaded={openCommunicationForAdminMessage}
                                                     refresh={refresh}/>

                                <div className={"safe-actions mt-1"}>
                                    <Button type={"submit"} key="submit" theme="blue mb-1" width={230}
                                            submitting={submitting}>Antwort absenden</Button>
                                </div>
                            </form>
                        </AccordionSection>
                    </div>
                </>
                }
            </Layout>
        </>
    )
}
